//import { MVPDto, MVPDtoImpl } from './mvpdto';
//import { Base64 } from 'js-base64';

export interface PasswordValidationDto
{
    getMsisdn(): string;
    getEncryptedPassword():string;
    getLanguage(): string;
    getSecurityCounter(): string;
}

export class PasswordValidationDtoImpl implements PasswordValidationDto
{
    private msisdn: string;
    private encryptedPassword: string;
    private language: string;
    private securityCounter: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getEncryptedPassword(): string 
    {
        return this.encryptedPassword;
    }
    setEncryptedPassword(passwordWithSecurityToken: string)
    {
        //console.log("PasswordWithSecurityToken B4 Base64 Encode:" + passwordWithSecurityToken);
        //this.encryptedPassword = encodeURIComponent(passwordWithSecurityToken);
        //this.encryptedPassword = Base64.encode(passwordWithSecurityToken);
        //console.log("PasswordWithSecurityToken Af Base64 Encode:" + this.encryptedPassword);
        this.encryptedPassword = passwordWithSecurityToken;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getSecurityCounter(): string 
    {
        return this.securityCounter;
    }
    setSecurityCounter(securityCounter: string) 
    {
        this.securityCounter = securityCounter;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/passwordvalidation/passwordvalidationdto.tsx